const DefaultVirtualScrollSettings = {
  Start: 0,
  RowHeight: 32,
  ContainerHeight: 0,
  MinPageSize: 30,
  Buffer: 5,
};

export default {
  data() {
    return {
      virtualScrollStart: DefaultVirtualScrollSettings.Start,
      virtualScrollRowHeight: DefaultVirtualScrollSettings.RowHeight,
      virtualScrollContainerHeight: DefaultVirtualScrollSettings.ContainerHeight,
      virtualScrollMinPageSize: DefaultVirtualScrollSettings.MinPageSize,
      virtualScrollBuffer: DefaultVirtualScrollSettings.Buffer,
      virtualScrollContainer: null,
      virtualScrollItems: [],
    };
  },
  computed: {
    /**
     * (optional, keep virtualScrollContainerHeight in 0 to use default)
     * Number of items loaded into the DOM.
     * If the container is too tall, this is calculated to fill the container and the buffers,
     * if not, the default virtualScrollMinPageSize is used
     */
    virtualScrollPerPage() {
      if (this.virtualScrollContainerHeight === 0) {
        return this.virtualScrollMinPageSize;
      }
      let customSize = 0;
      let rowsDisplayed = Math.ceil(this.virtualScrollContainerHeight / this.virtualScrollRowHeight);
      customSize = rowsDisplayed + (2 * this.virtualScrollBuffer);
      if (customSize > this.virtualScrollMinPageSize) {
        return customSize;
      }
      return this.virtualScrollMinPageSize;
    },
    /**
     * Items loaded into the DOM.
     */
    virtualScrollVisibleItems() {
      if (this.virtualScrollItems.length <= this.virtualScrollPerPage) {
        return this.virtualScrollItems;
      }
      return this.virtualScrollItems.slice(this.virtualScrollStart, this.virtualScrollPerPage + this.virtualScrollStart);
    },
    /**
     * Height of the top filler element for the scroller.
     * This will allow for consistent scrolling motion and
     * a component of the correct height to show skeleton loaders.
     * See Contacts/Index.vue for example
     */
    virtualScrollStartHeight() {
      return this.virtualScrollStart * this.virtualScrollRowHeight;
    },
    /**
     * Height of the bottom filler element for the scroller.
     * This will allow for consistent scrolling motion and
     * a component of the correct height to show skeleton loaders.
     * See Contacts/Index.vue for example
     */
    virtualScrollEndHeight() {
      return this.virtualScrollRowHeight * (this.virtualScrollItems.length - this.virtualScrollStart - this.virtualScrollPerPage);
    },
  },
  methods: {
    /**
     * Initializes the virtual scroller's properties
     * Call when scrollable element is mounted
     *
     * @param {Object} options Object that contains several options to customize scroller's behaviour
     */
    initializeVirtualScroller(options) {
      this.virtualScrollItems = options.items;
      this.virtualScrollContainer = options.container;
      if (options.start) {
        this.virtualScrollStart = options.start;
      }
      if (options.rowHeight) {
        this.virtualScrollRowHeight = options.rowHeight;
      }
      if (options.containerHeight) {
        this.virtualScrollContainerHeight = options.containerHeight;
      }
      if (options.minPageSize) {
        this.virtualScrollMinPageSize = options.minPageSize;
      }
      if (options.buffer) {
        this.virtualScrollBuffer = options.buffer;
      }
    },
    /**
     * Updates the virtual scroller's container height
     * Bind this method to the windows's 'resize' event listeners
     *
     * @param {Number} height Scrollable element's height in pixels
     */
    updateVirtualScrollerContainerHeight(height) {
      this.virtualScrollContainerHeight = height;
    },
    /**
     * Updates the virtual scroller's items
     * Call this method in a watcher for the items
     *
     * @param {Object} items Scrollable items list
     */
    updateVirtualScrollerItems(items) {
      this.virtualScrollItems = items;
    },
    /**
     * Calculates the position of the container and the new visible items after a scroll event
     * positioning the scroll to the correct position
     * Bind this method to the container's 'scroll' event listener
     *
     * @param {Object} items Scrollable items list
     */
    onVirtualScroll(e) {
      const { scrollTop } = this.virtualScrollContainer;
      var rows = Math.ceil(scrollTop / this.virtualScrollRowHeight);

      rows = rows >= this.virtualScrollBuffer ? rows - this.virtualScrollBuffer : 0;

      this.virtualScrollStart = rows + this.virtualScrollPerPage > this.virtualScrollItems.length ?
        this.virtualScrollItems.length - this.virtualScrollPerPage : rows;

      this.$nextTick(() => {
        this.virtualScrollContainer.scrollTop = scrollTop;
      });
    },
    /**
     * Returns the container's scroll to the top
     * Call this method on pagination changes
     *
     */
     virtualScrollToTop() {
      this.virtualScrollContainer.scrollTop = 0;
      this.onVirtualScroll();
    },
  },
};
